import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaBook, FaUserGraduate, FaBookmark, FaRegBookmark } from "react-icons/fa";
import { MdAccessTime } from "react-icons/md";
import { IoEyeSharp } from "react-icons/io5";
import { fetchPdf } from "../../api/slice/otherPdfSlice.js"; // Import the action

const OtherPdf = () => {
  const dispatch = useDispatch();

  // Get the data, loading, and error states from Redux
  const { pdf, loading, error } = useSelector((state) => state.pdf);

  // State to manage saved PDFs and save counts (you might want to use Redux for this if needed)
  const [savedPdfs, setSavedPdfs] = useState([]); // Track saved PDFs by their ID
  const [saveCounts, setSaveCounts] = useState({}); // Track save counts by PDF ID

  useEffect(() => {
    // Dispatch action to fetch PDF data
    dispatch(fetchPdf());
  }, [dispatch]);

  // Handle loading and error states
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleSave = (pdfId, username) => {
    // Implement logic to save PDF
    setSavedPdfs([...savedPdfs, pdfId]); // Add to saved PDFs
    setSaveCounts((prevCounts) => ({
      ...prevCounts,
      [pdfId]: (prevCounts[pdfId] || 0) + 1, // Increment save count for the specific PDF
    }));
    console.log(`Saving PDF ${pdfId}`);
  };

  const handleUnsave = (pdfId) => {
    // Implement logic to unsave PDF
    setSavedPdfs(savedPdfs.filter((id) => id !== pdfId)); // Remove from saved PDFs
    setSaveCounts((prevCounts) => ({
      ...prevCounts,
      [pdfId]: (prevCounts[pdfId] || 0) - 1, // Decrement save count for the specific PDF
    }));
    console.log(`Unsaving PDF ${pdfId}`);
  };

  return (
    <div className="grid grid-cols-3 gap-8 md:grid-cols-1">
      {pdf.map((item) => (
        <div
          key={item.id}
          className="box rounded-lg shadow-shadow1 bg-white"
        >
          <div className="images rounded-t-lg relative overflow-hidden w-full">
            <img
              src={item.image_path} // Use the image path from the API
              onClick={() => console.log(item)} // Handle click (can be replaced with your logic)
              alt={item.title}
              style={{ height: "250px" }}
              className="rounded-t-lg object-cover w-full transition ease-in-out delay-150 cursor-pointer hover:scale-125 duration-300"
            />
            <div className="categ flex gap-4 absolute top-0 m-3">
              <span className="text-[14px] bg-blue-700 p-1 px-3 text-white rounded-[5px] shadow-md">
                {item.subject}
              </span>
              <span className="text-[14px] bg-pink-700 p-1 px-3 text-white rounded-[5px] shadow-md">
                <h3 className="text-black" style={{ fontSize: "15px", color: "white" }}>
                  {item.course.includes("(") ? item.course.match(/\(([^)]+)\)/)[1] : item.course}
                </h3>
              </span>
            </div>
          </div>
          <div className="text p-3">
            <h3 className="text-black font-medium h-10" style={{ marginTop: "10px", color: "blue", marginBottom: "20px", fontSize: "15px" }}>
              {item.title.split(" ").slice(0, 10).join(" ")} {item.title.split(" ").length > 10 ? "..." : ""}
            </h3>
            <h3 className="text-black font-medium">
              {item.description.split(" ").slice(0, 7).join(" ")} {item.description.split(" ").length > 7 ? "..." : ""}
            </h3>
            <div style={{ marginBottom: "15px" }}>
              <div
                style={{
                  display: "flex",
                  gap: "30px",
                  marginTop: "10px",
                }}
              >
                <span className="text-[14px] bg-blue-700 p-1 px-3 text-white rounded-[5px] shadow-md">
                  Semester : {item.semester}
                </span>
                <span className="text-[14px] bg-pink-700 p-1 px-3 text-white rounded-[5px] shadow-md">
                  Year : {item.year}
                </span>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between border-t border-gray-200 p-3">
            <div className="user flex items-center">
              <FaUserGraduate />
              <span className="text-[14px] ml-2">{item.username.length > 5 ? `${item.username.substring(0, 6)}....` : item.username}</span>
            </div>

            <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IoEyeSharp />
              {item.views || 0}
            </span>

            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {savedPdfs.includes(item.id) ? (
                <FaBookmark
                  style={{ fontSize: "28px", color: "#007BFF" }}
                  className="cursor-pointer"
                  onClick={() => handleUnsave(item.id)} // Handle unsave on click
                />
              ) : (
                <FaRegBookmark
                  style={{ fontSize: "28px" }}
                  className="cursor-pointer"
                  onClick={() => handleSave(item.id, item.username)} // Handle save on click
                />
              )}
              <span>{saveCounts[item.id] || 0}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OtherPdf;
